import { render, staticRenderFns } from "./AyudaMenuCategoria.vue?vue&type=template&id=586902df&scoped=true&"
import script from "./AyudaMenuCategoria.vue?vue&type=script&lang=js&"
export * from "./AyudaMenuCategoria.vue?vue&type=script&lang=js&"
import style0 from "./AyudaMenuCategoria.vue?vue&type=style&index=0&id=586902df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586902df",
  null
  
)

export default component.exports